export default __webpack_public_path__ + "static/media/12.1231b4dd.jpg";